<div class="design-screen" *ngIf="isReady">
    <app-report-new-preview class="column report-preview" (closeSnackBar)="closeSnackBar($event)"></app-report-new-preview>
</div>
  